import React from "react";
import { useScreen } from "@danishagro/shared/src/contexts/screen.context";
import { _ListOfEmployeesDesktop } from "./components/ListOfEmployeesDesktop/ListOfEmployeesDesktop.component";
import { _ListOfEmployeesMobile } from "./components/ListOfEmployeesMobile/ListOfEmployeesMobile.component.tsx";

export interface V1Props {
    invite?: boolean;
}

export const V1 = (props: V1Props) => {
    const { isMobileOrTablet } = useScreen();

    return isMobileOrTablet ? (
        <_ListOfEmployeesMobile invite={props.invite} />
    ) : (
        <_ListOfEmployeesDesktop invite={props.invite} />
    );
};
